import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Alert
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

function AdminAuth({ open, onClose }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    // Check for auto-login parameters in URL
    const params = new URLSearchParams(location.search);
    const autoUsername = params.get('u');
    const autoPassword = params.get('p');
    
    if (autoUsername && autoPassword) {
      // Decode the base64 credentials
      try {
        const decodedUsername = atob(autoUsername);
        const decodedPassword = atob(autoPassword);
        
        if (decodedUsername === 'admin' && decodedPassword === 'Bingo69@2022') {
          sessionStorage.setItem('adminAuthenticated', 'true');
          navigate('/admin');
        }
      } catch (error) {
        console.error('Invalid credentials format');
      }
    }
  }, [navigate, location]);

  const handleLogin = () => {
    if (username === 'admin' && password === 'Bingo69@2022') {
      sessionStorage.setItem('adminAuthenticated', 'true');
      onClose();
      navigate('/admin');
    } else {
      setError('Invalid username or password');
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>Admin Login</DialogTitle>
      <DialogContent>
        {error && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {error}
          </Alert>
        )}
        <TextField
          autoFocus
          margin="dense"
          label="Username"
          type="text"
          fullWidth
          value={username}
          onChange={(e) => setUsername(e.target.value)}
        />
        <TextField
          margin="dense"
          label="Password"
          type="password"
          fullWidth
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={handleLogin}>Login</Button>
      </DialogActions>
    </Dialog>
  );
}

export default AdminAuth;
